import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Components/Sidebar";

const ProtectedRoute = (props) => {
    const history = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [Loading, setLoading] = React.useState(false);

    const checkUserToken = () => {
        const Info = localStorage.getItem('uid');
        if (!Info || Info === 'undefined') {
            setIsLoggedIn(false);
            return history("/");
        }
        setIsLoggedIn(true);
    }
    
    useEffect(() => {
            checkUserToken();
        }, [isLoggedIn]);


        


    return (
        <>
            {
                isLoggedIn ?
                <>

                  <Sidebar
				Loading={Loading}
				// Permissions={JSON.parse(Info)?.res.Permission}
			/> 
			<div className='table'>
           {  props.children}
</div>
                </>
                : null
            }
        </>
    );
}
export default ProtectedRoute;